import Vue from "vue";
import Vuex from "vuex";
import cfStoreFunction from "../../capital-finder-vuex/lib";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

console.log(process.env.API_URL);

const cfStore = cfStoreFunction({
  apiUrl: process.env.API_URL,
  clientId: process.env.CLIENT_ID,
  clientSecret: process.env.CLIENT_SECRET,
  resultsPerPage: 12,
  maxResults: 10000
});

var sequence = [
  "provider",
  "general-info",
  "key-statistics",
  "contact-page",
  "locale-page",
  "deal-page",
  "submit"
];

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    mode: "null",
    position: "provider",
    oneTimeAccess: false
  },
  modules: {
    cfStore: cfStore
  },
  getters: {
    isEditMode(state) {
      return state.mode == "edit";
    },
    isCreateMode(state) {
      return state.mode == "create";
    },
    isReviewMode(state) {
      return state.mode == "review";
    },
    isUploadMode(state) {
      return state.mode == "upload";
    },
    isNullMode(state) {
      return state.mode == "null";
    },
    oneTimeAccess(state) {
      return state.oneTimeAccess;
    },
    next(state) {
      if (sequence.indexOf(state.position) != -1) {
        return sequence[sequence.indexOf(state.position) + 1];
      } else {
        return undefined;
      }
    },
    current(state) {
      return sequence[sequence.indexOf(state.position)];
    },
    prev(state) {
      return sequence[sequence.indexOf(state.position) - 1];
    }
  },
  mutations: {
    setNullMode(state) {
      state.mode = "null";
    },
    setEditMode(state) {
      state.mode = "edit";
    },
    setCreateMode(state) {
      state.mode = "create";
    },
    setReviewMode(state) {
      state.mode = "review";
    },
    setUploadMode(state) {
      state.mode = "upload";
    },
    setOneTimeAccess(state, payl) {
      state.oneTimeAccess = payl;
    },
    setposition(state, position) {
      state.position = position;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js